function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.5,
  y1: 1.52,
  x2: 0.5,
  y2: 0.53,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#002740"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#002740"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "Trac\\xE9_1822",
  "data-name": "Trac\\xE9 1822",
  d: "M23.279,0H9.879A9.886,9.886,0,0,0,0,9.879v13.4a9.885,9.885,0,0,0,9.879,9.873h13.4a9.89,9.89,0,0,0,9.879-9.879V9.879A9.894,9.894,0,0,0,23.279,0Zm6.54,23.279a6.543,6.543,0,0,1-6.54,6.54H9.879a6.543,6.543,0,0,1-6.54-6.54V9.879a6.543,6.543,0,0,1,6.54-6.54h13.4a6.543,6.543,0,0,1,6.54,6.54v13.4Z",
  fill: "url(#linear-gradient)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  id: "Trac\\xE9_1823",
  "data-name": "Trac\\xE9 1823",
  d: "M141.574,133a8.574,8.574,0,1,0,8.574,8.574A8.582,8.582,0,0,0,141.574,133Zm0,13.814a5.241,5.241,0,1,1,5.241-5.241A5.241,5.241,0,0,1,141.574,146.814Z",
  transform: "translate(-124.998 -124.998)",
  fill: "url(#linear-gradient)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  id: "Ellipse_250",
  "data-name": "Ellipse 250",
  cx: 2.052,
  cy: 2.052,
  r: 2.052,
  transform: "translate(23.116 6.017)",
  fill: "url(#linear-gradient)"
});

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Groupe_3098",
    "data-name": "Groupe 3098",
    width: 33.158,
    height: 33.152,
    viewBox: "0 0 33.158 33.152",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.29159eb7.svg";
export { ForwardRef as ReactComponent };